import styled, {css} from "styled-components";
import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import ExitButtonPurple from "../../buttons/ExitButtonPurple";
import swotIcon from "../../../images/SWOT/SWOTColoured.svg"
import paramIcon from "../../../images/nav/settings.svg"
import homeIcon from "../../../images/nav/home.svg"
import teamIcon from "../../../images/groups.svg"
import ideaIcon from "../../../images/Ideation.svg"
import okrIcon from "../../../images/OKR/OKR_target.svg"
import actionIcon from "../../../images/nav/actions.svg"
import evaliationIcon from "../../../images/nav/rocket.svg"
import pitchProjectIcon from "../../../images/EnjoyNews.svg"
const FunctionalSection = ({component: Component, minCount, maxCount, count, setCount}) => {

    const {name} = useSelector(state => state.project)
    const [sectionTitle, setSectionTitle] = useState("Accueil")
    const navigate = useNavigate();

    const back = () => {
        navigate(-1);
    }

    const previous = () => {
        setCount(count - 1);
    }
    const next = () => {
        setCount(count + 1);
    }

    const data = [
        {count: 0, title: 'Paramétrer le projet', icon: paramIcon},
        {count: 1, title: 'Accueil', icon: homeIcon},
        {count: 2, title: 'Analyse projet (SWOT)', icon: swotIcon},
        {count: 3, title: "Équipe", icon: teamIcon},
        {count: 4, title: "Idéation", icon: ideaIcon},
        {count: 5, title: 'Objectifs / Indicateurs (OKR)', icon: okrIcon},
        {count: 6, title: 'Plan d\'action', icon: actionIcon},
        {count: 7, title: 'Bilan et évaluation', icon: evaliationIcon},
        {count: 8, title: 'Pitch projet', icon: pitchProjectIcon},
    ]

    useEffect(() => {
        const currentStep = data.find(step => step.count === count);
        if (currentStep) {
            setSectionTitle(currentStep.title);
        }
    }, [count]);
    return (
        <Section>
            <Container $mode={count > maxCount ? "none" : ""}>
                <FirsSection>
                    <Name> Mise à jour du projet "<span style={{color: "#7C51BD"}}> {name} </span>", section "<span style={{color: "#7C51BD"}}> {sectionTitle} </span> "</Name>
                    <ExitButtonPurple
                        closeUpdate={back}
                    />
                </FirsSection>
                <SecondSection>
                    <SectionDisplayed>
                        {Component}
                    </SectionDisplayed>
                    <Summary>
                        {
                            /**
                             * ### Prev and Next buttons ###
                             *
                             * <NavContainer>
                             *                             <div>
                             *                                 {
                             *                                     count > 1 &&
                             *                                     <SummaryItems  $mode={"prev"} onClick={previous}>
                             *                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                             *                                              xmlns="http://www.w3.org/2000/svg">
                             *                                             <circle cx="12" cy="12" r="12" transform="rotate(90 12 12)" fill="white"/>
                             *                                             <path
                             *                                                 d="M14.6891 16.1611L10.5645 11.9946L14.6891 7.82819C15.1036 7.4094 15.1036 6.73289 14.6891 6.31409C14.2745 5.8953 13.6048 5.8953 13.1902 6.31409L8.31093 11.243C7.89636 11.6617 7.89636 12.3383 8.31093 12.757L13.1902 17.6859C13.6048 18.1047 14.2745 18.1047 14.6891 17.6859C15.093 17.2671 15.1036 16.5799 14.6891 16.1611Z"
                             *                                                 fill="#4909AA"/>
                             *                                         </svg>
                             *                                         <p>Précédent</p>
                             *                                     </SummaryItems>
                             *                                 }
                             *                             </div>
                             *                             <div>
                             *                                 {
                             *                                     count < maxCount &&
                             *                                     <SummaryItems $mode={"next"} onClick={next}>
                             *                                         <p>Suivant</p>
                             *                                         <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                             *                                              xmlns="http://www.w3.org/2000/svg">
                             *                                             <circle cx="12" cy="12" r="12" transform="rotate(90 12 12)" fill="white"/>
                             *                                             <path
                             *                                                 d="M14.6891 16.1611L10.5645 11.9946L14.6891 7.82819C15.1036 7.4094 15.1036 6.73289 14.6891 6.31409C14.2745 5.8953 13.6048 5.8953 13.1902 6.31409L8.31093 11.243C7.89636 11.6617 7.89636 12.3383 8.31093 12.757L13.1902 17.6859C13.6048 18.1047 14.2745 18.1047 14.6891 17.6859C15.093 17.2671 15.1036 16.5799 14.6891 16.1611Z"
                             *                                                 fill="#4909AA"/>
                             *                                         </svg>
                             *                                     </SummaryItems>
                             *                                 }
                             *                             </div>
                             *                         </NavContainer>
                             * */
                        }
                        {data.map(d => (
                            <li key={d.title}>
                                <SummaryItems className={d.count === count ? "reverse" : null}
                                              onClick={() => {
                                                  setCount(d.count)
                                              }}>
                                    {d.icon? <img src={d.icon} alt={"icon " + d.title} /> : "" }
                                    <p> {d.title}</p>
                                </SummaryItems>
                            </li>
                        ))}
                    </Summary>
                </SecondSection>
            </Container>
        </Section>
    )
}

const Section = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: var(--color-purple-lighten);
  overflow-y: auto;

`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 2rem;
  gap: 1rem;
  overflow-y: auto;
  background-color: var(--color-white);
  width: 100%;

  h1, h2 {
    text-align: center;
  }

  @media (min-width: 900px) {
    ${(props) => {
      switch (props.$mode) {
        case "none":
          return css`
            background-color: transparent;
          `;
        default:
          return css`
            width: 90%;
            height: 90%;
            border-radius: 15px;
            box-shadow: rgb(15 15 15 / 5%) 0 0 0 1px, rgb(15 15 15 / 10%) 0 3px 6px, rgb(15 15 15 / 20%) 0 9px 24px;
          `;
      }
    }}
  }
  @media (min-width: 1600px) and (max-height: 800px) {
    height: calc(100% - 100px);
    width: 80%;
  }
  @media (min-width: 1600px) and (min-height: 800px) {
    width: 1600px;
    height: calc(100% - 200px);
  }
`
const Name = styled.p`
  font-size: 18px;
  text-align: center;
  font-weight: 700;
  flex-grow: 1;
  max-width: 80%;
`

const FirsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  @media (min-width: 900px) {
    flex-direction: row;
    justify-content: space-between;  
    align-items: center;
  }
`
const SecondSection = styled.div`
  display: grid;
  grid-template-columns: 80% minmax(15%, 1fr);
  gap: 0.5rem ;
`

const SectionDisplayed = styled.div`
    box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.25);
    border-radius: 15px;
    padding: 0.5rem;
    height: 75vh;
    overflow-y: scroll;
`
const Summary = styled.ul`
  display: flex;
  flex-direction: column;
  margin: auto;
  gap: 1rem;
  width: 100%;
  align-self: center;
    .reverse{
        background: var(--color-white);
        cursor: pointer;
        border-color: var(--color-purple-06);

        p {
            color: var(--color-purple-06);
        }
    }
`
const SummaryItems = styled.button`
  display: flex;
  gap: 0.2rem;
  border: 2px solid transparent;
  background: var(--color-purple-06);
  width: 100%;
  height: 100%;
  text-align: left;
  border-radius: 5px;
  padding: 0.5rem;
  align-items: center;
  transition: all ease 0.2s;
    img{
        width: 18px;
    }
    p {
        color: var(--color-white);
        font-size: 13px;
        font-weight: bold;
    }
  &:hover {
    background: var(--color-white);
    cursor: pointer;
    border-color: var(--color-purple-06);

    p {
        color: var(--color-purple-06);
    }
  }
    ${(props) => {
        switch (props.$mode) {
            case "next":
                return css`
                  svg{
                      transform: rotate(180deg);
                  }
                  @media screen and (min-width: 1270px) {
                      justify-content: flex-end;
                  }
        `;
            default:
                return css`
        `;
        }
    }}
    
`

const NavContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    
    @media (min-width: 1270px) {
        display: grid;
        grid-template-columns: 48.5% 48.5%;
        gap: 0.5rem;
    }
`

export default FunctionalSection